// 初回のみ動画を表示
const keyName = 'visited';
const keyValue = true;
if (!sessionStorage.getItem(keyName)) {

    //sessionStorageにキーと値を追加
    sessionStorage.setItem(keyName, keyValue);

    //ここに初回アクセス時の処理
    var player = $('#opening .video').get(0);
    player.play();

    //タイマーで動画をフェードアウト
    setTimeout(function () {
        // var player = $('#opening .video').get(0);
        // player.pause();
        $('#opening').fadeOut(1000);
    }, 7000);

    // 直後に動画を削除・bodyのスタイル設定
    setTimeout(function () {
        $('#opening').remove();
        $('body').css('overflow-y', 'auto');
    }, 9000);

} else {

    //ここに通常アクセス時の処理
    $('#opening').remove();
    $('body').css('overflow-y', 'auto');

}

// ハンバーガーメニューの表示制御
$('#mobile-nav-btn').on('click', function () {
    $('.nav-bar').fadeIn(200);
    $('body').addClass('nav-open');
});
$('#mobile-nav-close').on('click', function () {
    $('.nav-bar').fadeOut(200);
    $('body').removeClass('nav-open');
});

// ニューススライダーの閉じるボタン
// $('.news-slider .close-btn').on('click', function () {
//     $('.news-slider').css('height', '0px');
//     $('.news-slider .close-btn').css('display', 'none');
//     setTimeout(function () {
//         $('.news-slider').remove();
//     }, 300);
// });

// タブの切り替え
$(function () {
    $('.js-tab').click(function () {
        var index = $('.js-tab').index(this);

        $('.js-tab').removeClass('active');
        $(this).addClass('active');
        $('.js-panel').removeClass('show').eq(index).addClass('show');
    });
});

// カテゴリ検索BOXの表示制御
$('.site-header .search-bar input[type=search]').on('click', function () {
    $('#search-category').fadeIn(200);
});
// カテゴリ検索BOXの閉じるボタン
$('#search-category .icon-close').on('click', function () {
    $('#search-category').fadeOut(200);
});
// 検索バーの入力候補補足をOFF
$('.site-header .search-bar input[type=search]').attr('autocomplete', 'off');

// ブランドポイントのアコーディオン切り替え
$(function () {
    $('.acd-title').click(function () {
        if ($(this).prev().prop("checked") == true) {
            $(this).parent().parent().removeClass('open');
        } else {
            $(this).parent().parent().addClass('open');
        }
    });
});

// 住所の追加・編集フォーム表示制御
$(function () {
    $('.address-add-btn').click(function () {
        if ($(this).next().hasClass("open")) {
            $(this).next().removeClass('open');
        } else {
            $(this).next().addClass('open');
        }
    });

    $('.address-edit-btn a').click(function () {
        if ($(this).parent().parent().next().hasClass("open")) {
            $(this).parent().parent().next().removeClass('open');
        } else {
            $(this).parent().parent().next().addClass('open');
        }
    });

    $('.address-cancel-btn').click(function () {
        $(this).parent().parent().removeClass('open');
    });
});

// タブのダイレクトリンク
$(function () {
    var hash = location.hash;

    //hashに#tab～が存在する場合 
    if (hash.match(/#tab/)) {
        // hashで取得した文字列（#tab2,#tab3等）から#より後を取得(tab2,tab3)
        var tabname = hash.slice(1);

        //コンテンツを一度すべて非表示に
        $('.js-panel').css('display', 'none');

        //一度タブについているクラスactiveを消す
        $('.js-tab').removeClass('active');
        $('.js-panel').removeClass('show');

        //クリックされたタブと同じ順番のコンテンツを表示します。
        var index = $('.js-tab-wrapper div#' + tabname).index();

        $('.js-panel').eq(index).addClass('show');
        $('.js-panel').eq(index).fadeIn();
        $('.js-tab').eq(index).addClass('active')
        $('.js-tab').eq(index).click();
    }
});

// お気に入りリストのカスタマイズ
$(window).on('load', function () {
    $('.ZoomyWishlistPageGrid span.zprice').each(function () {

        // 金額の小数点以下削除、カンマ区切り
        let zprice_text = $(this).text();
        zprice_text = zprice_text.replace(".00", "");
        zprice_text = zprice_text.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');

        // ポイント
        let zprice_num = zprice_text.replace(",", "").slice(1);
        let point_value = Math.floor(zprice_num / 100);

        let zprice_html = zprice_text + '<span class="tax rte">（税込）</span><br><span class="product-point">' + point_value + 'P</span>';
        $(this).html(zprice_html);
    });
});

// お問い合わせフォームのオプトイン
$(function () {
    $('#optin').change(function () {
        var prop = $('#optin').prop('checked');

        if (prop) {
            $('#contact_submit').prop('disabled', false);
        } else {
            $('#contact_submit').prop('disabled', true);
        }
    });
});

// 新しいタブで外部リンクを開く
var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if ((links[i].hostname !== window.location.hostname) && (links[i].href !== 'javascript:void(0);')) {
        links[i].target = '_blank';
        links[i].relList.add('noreferrer', 'noopener');
    }
}